<template>
  <v-container id="main-content">
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      top
      color="#1976d2"
    />
      <section v-if="visibilitySection.home">
        <h2 class="header-content-visible-link-warning" v-if="visibleLinkWarning">{{ linkWarning }}</h2>
        <div v-else>
          <h1 class="header-content-block-h1">{{ pageTitle }}</h1>
          <p class="header-content-block-p">{{ pageDescription }}</p>
          <v-row class="row-content-center">
              <v-col
                  md="8"
                  cols="12"
                  order="2"
                  order-md ="1"
                  id="container-date-piker"
              >
                  <v-card v-if="!loading">
                      <v-date-picker
                          class="crm-date-picker"
                          color="#2a6ebb"
                          v-model="pickerDate"
                          :allowed-dates="allowedDates"
                          :min="minDate"
                          full-width="full-width"
                          v-on:click:date="clickDatePiker"
                      />
                      <v-row id="select-time-zone">
                          <v-col cols="9">
                              <v-select
                                  v-model="timeZoneLead"
                                  :items="listTimeZones"
                                  item-text="banner"
                                  item-value="timeZone"
                                  label="Select Time Zone"
                                  prepend-icon="mdi-web-clock"

                                  dense
                                  :menu-props="{ auto: true, top: true, offsetY: true }"
                              />
                          </v-col>
                          <v-col id="time-time-zone" class="span-time-zone" cols="3">
                              <span> - {{ myTime }}</span>
                          </v-col>
                      </v-row>
                  </v-card>
              </v-col>
              <v-col
                  id="container-tab-booking"
                  md="4"
                  cols="12"
                  order="1"
                  order-md='2'
                  v-if="visibilitySection.tabBooking"
              >
                  <tab-booking/>
              </v-col>
          </v-row>
        </div>

      </section>
      <schedule-meeting id="schedule-page" v-if="visibilitySection.schedule"></schedule-meeting>
      <confirm-meeting v-if="visibilitySection.confirmMeeting"></confirm-meeting>
  </v-container>
</template>
<script>
  import moment from 'moment-timezone';
  import tabBooking from "./tabBooking";
  import scheduleMeeting from "./scheduleMeeting";
  import confirmMeeting from "./confirmMeeting";
  import xlooLib from "../xlooLib/xlooLib";


  export default {
    // eslint-disable-next-line vue/no-unused-components
    components: { tabBooking, scheduleMeeting, confirmMeeting, xlooLib },
    name: "Home",
    data(){
      return {
        dateToday: null,
        timeZoneLead: null,
        timeZoneLeadOffset: null,
        timeZoneUser: null,
        linkWarning: '',
        visibleLinkWarning: false,

        myTime: null,
        nextMonth: null,

        hash: null,

        pageTitle: '',
        pageDescription: '',
        pickerDate:(new Date).toISOString().substr(0, 10),
        minDate: moment(new Date()).format('YYYY-MM-DD'),
        actualVisibleMonth: null,
        mouseMonth: null,
        resetDatePicker: false,

        loading: false,

        visibilitySection: {
          datepiker: false,
          home: true,
          tabBooking: false,
          schedule: false,
          confirmMeeting: false,
        },
        listTimeZones: [],
      }
    },
    watch : {
      timeZoneLead: async function(timeZone) {
        if (this.$store.getters.timeZoneUser === null) return;

        this.timeZoneLeadOffset = moment.tz(timeZone).format('Z');
        this.myTime = moment().utcOffset(this.timeZoneLeadOffset).format("h:mm A");

        this.$store.dispatch("set_deleteWorkerHours");
        let sliderDate = this.dateToday;

        this.loading = true;
        do {
          const disWorkedTime = xlooLib.workedTime(
              this.$store.getters.storeWorkedTime,
              this.$store.getters.arrBlockedDate,
              this.$store.getters.workHours,
              this.$store.getters.timeZoneUser,
              moment.tz(timeZone).format('Z'),
              moment(sliderDate).utcOffset(this.timeZoneLeadOffset).format("MM"),
              moment(sliderDate).utcOffset(this.timeZoneLeadOffset).format("YYYY"),
              this.$store.getters.meetingDuration,
              this.$store.getters.breakDuration
          );
          await this.$store.commit('set_storeWorkedTime', disWorkedTime);
          sliderDate = moment(sliderDate).add(1, 'month').format("YYYY-MM-DD");

        } while (Number(moment(sliderDate).format("YYYY") + moment(sliderDate).format("MM")) <= this.actualVisibleMonth)
        this.$store.commit("set_timeZoneLead", moment.tz(timeZone).format('Z'));
        this.$store.commit("set_timeZoneLeadBanner", this.timeZoneBanner(timeZone));

        this.loading = false;
      }
    },
    created: async function() {
      let hm = this;

      this.$root.$on("schedule", () => { hm.visibilitySection.home = false; hm.visibilitySection.schedule = true; })
      this.$root.$on('confirmed', () => { hm.visibilitySection.schedule = false; hm.visibilitySection.confirmMeeting = true; })
      this.$root.$on('home', () => { hm.visibilitySection.home = true; hm.visibilitySection.tabBooking = false; hm.visibilitySection.schedule = false; })
      this.$root.$on('loadingTrue', () => {  hm.loading = true;})
      this.$root.$on('loadingFalse', () => {  hm.loading = false;})

      this.loading = true;
      this.hash = this.$route.query.hash;

      this.actualVisibleMonth = Number(moment(new Date()).format("YYYY") + moment(new Date()).format("MM"));

      this.timeZoneLead = this.timeZoneLeadBanner = moment.tz.guess();
      this.$store.commit('set_timeZoneLeadBanner', moment.tz.guess());
      this.timeZoneLeadOffset = moment.tz(this.timeZoneLeadBanner).format('Z');

      const tzTimeZoneList = moment.tz.names();
      let offsetTmz = [];

      for(let iTzTimeZonelist in tzTimeZoneList)
      {
        offsetTmz.push({
          timeZoneOffset: moment.tz(tzTimeZoneList[iTzTimeZonelist]).format('Z'),
          timeZone: tzTimeZoneList[iTzTimeZonelist],
          banner:  moment.tz(tzTimeZoneList[iTzTimeZonelist]).format('Z') + ' - ' + tzTimeZoneList[iTzTimeZonelist],
        });
      }

      this.listTimeZones = offsetTmz.sort(sortFunction);
      function sortFunction(a, b){
        if (a.timeZoneOffset < b.timeZoneOffset) return -1;
        if (a.timeZoneOffset > b.timeZoneOffset) return 1;
        return 0;
      }

      this.dateToday = moment.utc(new Date()).utcOffset(this.timeZoneLead*60).format('YYYY-MM-DD');
      this.$store.commit('set_timeZoneLead', moment(this.dateToday).format('Z'));

      this.nextMonth =  moment.utc(new Date()).utcOffset(this.timeZoneLead).add(1, 'M').format('MM');
      this.actualVisibleMonth = Number(moment(this.dateToday).format("YYYY") +String(this.nextMonth));

      this.$store.commit('set_hash', this.hash);

      const dataFirstStep = {
          hash : this.hash,
          dateLink: this.$route.query.dateLink || '',
          month : moment(this.dateToday).utcOffset(this.timeZoneLeadOffset).format("MM"),
          year :  moment(this.dateToday).utcOffset(this.timeZoneLeadOffset).format("YYYY"),
      };
      const resFirstStep = await this.$store.dispatch("set_firstStep", dataFirstStep );

      switch (true){
          case !resFirstStep.result && typeof resFirstStep.description !== 'undefined':
              this.linkWarning = resFirstStep.description
              this.visibleLinkWarning = true
              break
      }

      this.minDate = moment(new Date()).add(this.$store.getters.blockXDaysToMeetings, 'd').format('YYYY-MM-DD')

      let customFavicon = document.querySelector(
          `head > link[rel='icon']`
      );
      customFavicon.href = this.$store.getters.faviconPath;

      document.title = this.$store.getters.pageName;

      this.pageTitle = this.$store.getters.pageTitle;
      this.pageDescription = this.$store.getters.pageDescription;
      this.leadWorkHours = this.$store.getters.storeWorkedTime;

      this.myTime = moment().utcOffset(this.timeZoneLeadOffset).format("h:mm A");
      this.nowTimes();

      this.loading = false;
    },
    methods:{
      nowTimes : function() {
        this.myTime = moment().utcOffset(this.timeZoneLeadOffset).format("HH:mm");
        setInterval(this.nowTimes, 30000);
      },

      timeZoneBanner: (timeZone) => moment.tz(timeZone).format('Z') + ' - ' + timeZone,

      clickDatePiker : async function(index) {
        await this.$store.commit("set_dateBooking", index);
        this.visibilitySection.tabBooking = true;
      },
      allowedDates(date){
        if (Number(moment(date).add(1, "M").format("YYYY") + moment(date).add(1, "M").format("MM")) >= this.actualVisibleMonth){
          this.actualVisibleMonth = Number(moment(date).add(2, "M").format("YYYY") + moment(date).add(2, 'M').format("MM"));

          const dataCalendar = {
            hash : this.$store.getters.hash,
            month : moment(date).add(2, "M").format("MM"),
            year : moment(date).add(2, "M").format("YYYY")
          };
          this.$store.dispatch('set_calendar', dataCalendar);
        }
        const givenDatesIndexed = this.$store.getters.storeWorkedTime;
        return typeof givenDatesIndexed[date] !== 'undefined';
      },
      visibleSchedule (){
        this.visibilitySection.home = false;
        this.visibilitySection.tabBooking = false;
        this.visibilitySection.schedule = true;
      }
    },
  }
</script>

<style scoped>
    .header-content-visible-link-warning{
        min-height: 36px;
        text-align: center;
        margin-top: 30px;
    }
    #main-content {
        max-width: 990px;
        min-height: 607px;
        width: 100%;
        margin: 15px;
        box-sizing: border-box;
        border-radius: 5px;
        background-color: #fff;
        box-shadow: 0 15px 25px 0 hsl(0deg 0% 53% / 25%);
        padding: 15px;
    }
    #container-date-piker{
      max-width: 450px;
    }
    .row-content-center{
        align-items: flex-start;
    }
    .crm-date-picker {
        width: fit-content;
        width: -moz-fit-content;
        max-height: 450px;
        margin-left: auto;
        margin-right: auto;
    }
    #select-time-zone{
        margin: 0 10px;
    }
    .col-time-zone{
        display: flex;
        align-items: center;
    }
    .col-time-zone-left{
        justify-content: flex-end;
    }
    .span-time-zone{
        z-index: 2;
    }
    #time-time-zone{
        display: flex;
        align-items: center;
        padding-left: 0;
        padding-right: 0;
    }
    #time-time-zone span{
        margin-bottom: 5px;
    }
    #container-tab-booking{
        max-width: 450px;
    }
    @media (max-width: 960px) {
        #container-tab-booking > div{
            width: 100%;
        }
    }
</style>
